import type * as Types from 'app/types/graphql';

export type UsageFeeTierEdgeSelectFragment = {
  edges?: Types.Maybe<
    Array<{
      node?: Types.Maybe<
        Pick<
          Types.UsageFeeTier,
          | 'id'
          | 'max'
          | 'min'
          | 'planID'
          | 'rangeSize'
          | 'amount'
          | 'currency'
          | 'source'
          | 'startAt'
          | 'endAt'
        >
      >;
    }>
  >;
};

export type UsageFeeTierSelectFragment = Pick<
  Types.UsageFeeTier,
  | 'id'
  | 'max'
  | 'min'
  | 'planID'
  | 'rangeSize'
  | 'amount'
  | 'currency'
  | 'source'
  | 'startAt'
  | 'endAt'
>;

export const UsageFeeTierSelectFragmentDoc = `
    fragment UsageFeeTierSelect on UsageFeeTier {
  id
  max
  min
  planID
  rangeSize
  amount
  currency
  source
  startAt
  endAt
}
    `;
export const UsageFeeTierEdgeSelectFragmentDoc = `
    fragment UsageFeeTierEdgeSelect on UsageFeeTierConnection {
  edges {
    node {
      ...UsageFeeTierSelect
    }
  }
}
    `;
